import { HotelSearchPanel } from "@website/accommodation-ui/hotel-search/hotel-search-panel";
import { HotelSearchSummary } from "@website/accommodation-ui/hotel-search/hotel-search-summary";
import { HotelSearchWrapper } from "@website/accommodation-ui/hotel-search/hotel-search-wrapper";
import { HotelSearchPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { deepCompare } from "@website/utils/deep-compare";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelSearchPropertiesType> = (properties) => {
  const {
    isSearchPanelOpen,
    setIsSearchPanelOpen,
    searchPanelProperties,
    searchSummaryProperties,
    searchType = "city",
    filterProps
  } = properties;
  const router = useRouter();

  return (
    <div>
      <div className="flex flex-row items-center gap-0 bg-white">
        <HotelSearchWrapper
          PanelElement={
            <HotelSearchPanel
              hasBtnClose
              {...searchPanelProperties}
              searchType={searchType}
            />
          }
          SummaryElement={
            <HotelSearchSummary
              {...searchSummaryProperties}
              searchType={searchType}
            />
          }
          isSearchPanelOpen={isSearchPanelOpen}
          searchType={searchType}
          setIsSearchPanelOpen={setIsSearchPanelOpen}
        />
        <Button
          className={`${
            router.pathname?.includes("map")
              ? "!me-4 block md:!hidden"
              : "!hidden"
          }`}
          color="neutral"
          onClick={filterProps?.toggleFilterModal}
          variant="text"
        >
          <MaterialIcon className="text-headline-6" name="tune" />
        </Button>
      </div>
    </div>
  );
};

export const HotelSearch = memo(Component, deepCompare);
